import { Routes, Route, Navigate, Link, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import DashboardLayout from '../../components/Dashboard/DashboardLayout'
import DashboardHome from './DashboardHome'
import EventsManagement from './EventsManagement'
import BrunchManagement from './BrunchManagement'
import UsersManagement from './UsersManagement'
import BewerbungManagement from './BewerbungManagement'
import Settings from './Settings'

export default function Dashboard() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Prüfe ob User eingeloggt ist
    const token = localStorage.getItem('dashboard_token')
    if (!token) {
      navigate('/dashboard/login')
    } else {
      setIsAuthenticated(true)
    }
  }, [navigate])

  if (!isAuthenticated) {
    return null
  }

  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<DashboardHome />} />
        <Route path="events" element={<EventsManagement />} />
        <Route path="brunches" element={<BrunchManagement />} />
        <Route path="users" element={<UsersManagement />} />
        <Route path="bewerbung" element={<BewerbungManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="media" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  )
}
















